<template>
    <div style="width: 100%;text-align: initial;">
        <div class="row" style="line-height: 2">
            <div class="col m4">{{$t('devices.measure_method')}}</div>
            <div class="col m3">
                <select v-model="criterium.method" @change="onChange()" :disabled="!edit_zones">
                    <option value="standard">{{$t('devices.standard')}}</option>
                    <option value="pests_quantity">{{$t('devices.pest_amount')}}</option>
                    <option value="substance_consumed">{{$t('devices.substance_consumed')}} %</option>
                    <option value="logic_value">{{$t('devices.logic_value')}}</option>
                </select>
                {{criterium.errors == undefined ? "" : criterium.errors.method}}
            </div>
        </div>
        <div class="row grey" style="width: 100%; padding: 15px 0px;">
            <div class="col s2">
                {{$t('devices.no_activity')}} <br />({{$t('routine_analyses.zero_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.low_activity')}} <br /> ({{$t('routine_analyses.one_point')}})
            </div>
            <div class="col s2">
                {{$t('devices.average_activity')}} <br /> ({{$t('routine_analyses.two_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.high_activity')}} <br />({{$t('routine_analyses.three_points')}})
            </div>
            <div class="col s2">
                {{$t('devices.very_high_activity')}} <br />({{$t('routine_analyses.four_points')}})
            </div>
            <div class="col s1" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                {{$t('devices.critical_point')}}
            </div>
            <div class="col s1" v-if="zone.has_disaster_point">
                {{$t('devices.catastrophal_point')}}
            </div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="criterium.method == 'standard'">
            <div class="col s2 input-field inline">
                <input v-model="criterium.no_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
                <input v-model="criterium.low_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
                <input v-model="criterium.medium_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
                <input v-model="criterium.high_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
                <input v-model="criterium.very_high_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col input-field inline" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                <input v-model="criterium.critical_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
            </div>
            <div class="col s1 input-field inline" v-if="zone.has_disaster_point">
                <input v-model="criterium.disaster_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
            </div>
            <div class="col s6 right-align" style="line-height: 2">{{$t('devices.critical_disaster')}}:</div>
            <div class="col s6">
                <select v-model="criterium.critical_calculation" :disabled="!edit_zones" @change="calcMethodChanged(criterium)">
                    <option value="anyof">{{$t('devices.each_device')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select>
            </div>
        </div>
        <template v-if="criterium.method == 'pests_quantity'">
            <div class="row grey" style="width: 100%;">
                <div class="col s2 input-field inline">
                    <input value="0" type="number" style="width: 47px;" disabled=""> szt.
                </div>
                <div class="col s2 input-field inline">
                    <input value="1" type="number" style="width: 47px;" disabled=""> &#8212;
                    <input v-model="criterium.medium_activity_thresold" type="number" style="width: 47px;" :disabled="!edit_zones" min="1" @change="criteriumChanged(criterium)" /> szt.
                </div>
                <div class="col s2 input-field">
                    <input :value="parse(criterium.medium_activity_thresold, 2) + 1" type="number" style="width: 47px;" disabled="" min="2" /> &#8212;
                    <input v-model="criterium.high_activity_thresold" type="number" style="width: 47px;" :disabled="!edit_zones" @change="criteriumChanged(criterium)" min="2" /> szt.
                </div>
                <div class="col s2 input-field">
                    <input :value="parse(criterium.high_activity_thresold, 3) + 1" type="number" style="width: 47px;" disabled="" min="3" /> &#8212;
                    <input v-model="criterium.very_high_activity_thresold" type="number" style="width: 47px;" :disabled="!edit_zones" @change="criteriumChanged(criterium)" min="3" /> szt.
                </div>
                <div class="col s2 input-field inline">
                    {{$t('devices.over')}} <input v-model="criterium.very_high_activity_thresold" type="number" style="width: 47px;" disabled="" @change="onChange()"/> szt.
                </div>
                <div class="col input-field inline" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                    <input v-model="criterium.critical_point" style="width: 47px;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
                </div>
                <div class="col s1 input-field inline" v-if="zone.has_disaster_point">
                    <input v-model="criterium.disaster_point" style="width: 47px;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
                </div>
                <div class="col s6 right-align" style="line-height: 2">{{$t('devices.critical_disaster')}}:</div>
                <div class="col s6">
                    <select v-model="criterium.critical_calculation" :disabled="!edit_zones" @change="calcMethodChanged(criterium)">
                        <option value="anyof">{{$t('devices.each_device')}}</option>
                        <option value="avg">{{$t('devices.average_devices')}}</option>
                    </select></div>
            </div>
            <div class="row " style="width: 100%; line-height: 2; margin-top: 15px;">
                <div class="col s12" v-if="criterium.pests_thresolds != undefined &&  criterium.pests_thresolds.length > 0">
                    {{$t('devices.target_pests')}}:
                </div>
            </div>
            <template v-for="pt in criterium.pests_thresolds" >
                <targetpest :pests="pestsByCategory" :pest_thresold="pt" :disabled="!edit_zones" :zone="zone" v-on:remove="removeTargetPest(criterium, pt)" v-on:changed="onChange()" v-if="pt._destroy != true"/>
            </template>
            <div class="row" style="width: 100%; padding-top: 15px; padding-bottom: 15px; line-height: 2">
                <div class="col s4 input-field"><a class="btn btn-small green" v-if="edit_zones" v-on:click="addTargetPest()">{{$t('devices.add_target_pest')}}</a></div>
            </div>
        </template>
        <div class="row grey tabel" style="width: 100%;" v-if="criterium.method == 'substance_consumed'">
            <div class="col s2 input-field ">
                0 %
            </div>
            <div class="col s2 input-field ">
                1 &#8212;
                <input type="number" v-model="criterium.medium_activity_thresold" min="1" max="99" @change="criteriumChanged(criterium)" style="width: 47px;" :disabled="!edit_zones" /> %
            </div>
            <div class="col s2 input-field ">
                {{parse(criterium.medium_activity_thresold, 2) + 1}} &#8212;
                <input type="number" v-model="criterium.high_activity_thresold" min="1" max="99" @change="criteriumChanged(criterium)" style="width: 47px;" :disabled="!edit_zones" /> %
            </div>
            <div class="col s2 input-field ">
                {{parse(criterium.high_activity_thresold, 3) + 1}} &#8212;
                <input type="number" v-model="criterium.very_high_activity_thresold" min="1" max="99" @change="criteriumChanged(criterium)" style="width: 47px;" :disabled="!edit_zones" /> %
            </div>
            <div class="col s2 input-field">
                {{parse(criterium.very_high_activity_thresold, 4) + 1}} &#8212; 100%</div>
            <div class="col input-field" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                <input v-model="criterium.critical_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
            </div>
            <div class="col s1 input-field" v-if="zone.has_disaster_point">
                <input v-model="criterium.disaster_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()"/>
            </div>
            <div class="col s6 right-align" style="line-height: 2">{{$t('devices.critical_disaster')}}:</div>
            <div class="col s6">
                <select v-model="criterium.critical_calculation" :disabled="!edit_zones" @change="calcMethodChanged(criterium)">
                    <option value="anyof">{{$t('devices.each_device')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select></div>
        </div>
        <div class="row grey" style="width: 100%;" v-if="criterium.method == 'logic_value'">
            <div class="col s2 input-field inline">
                <input v-model="criterium.no_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s2 input-field inline">
                <input v-model="criterium.high_activity_text" :disabled="!edit_zones" @change="onChange()"/>
            </div>
            <div class="col s2 input-field inline">
            </div>
            <div class="col s1 input-field inline">
                <input v-model="criterium.critical_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()" />
            </div>
            <div class="col input-field inline" v-if="zone.has_disaster_point" :class="{ s1: zone.has_disaster_point, s2: !zone.has_disaster_point }">
                <input v-model="criterium.disaster_point" style="width: 75%;" :disabled="!edit_zones" max="4" min="0" step=".1" type="number"  @change="onChange()" />
            </div>
            <div class="col s6 right-align" style="line-height: 2">{{$t('devices.critical_disaster')}}:</div>
            <div class="col s6">
                <select v-model="criterium.critical_calculation" :disabled="!edit_zones" @change="calcMethodChanged(criterium)">
                    <option value="anyof">{{$t('devices.each_device')}}</option>
                    <option value="avg">{{$t('devices.average_devices')}}</option>
                </select></div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            touched: false
        }
    },
    props: {
        criterium: Object,
        zone: Object,
        pests: Array,
        edit_zones: Boolean,
        group: String
    },
    methods: {
        onChange() {
            this.$forceUpdate();
            this.changeOccured();
        },
        criteriumChanged(crit) {
            if (crit.medium_activity_thresold == '') {
                crit.medium_activity_thresold = 2;
            }
            if (crit.high_activity_thresold == '') {
                crit.high_activity_thresold = 3;
            }
            if (crit.very_high_activity_thresold == '') {
                crit.very_high_activity_thresold = 4;
            }
            if (crit.method == 'substance_consumed' && crit.very_high_activity_thresold >= 99) {
                crit.very_high_activity_thresold = 98;
            }
            if (parseInt(crit.medium_activity_thresold) < 1) {
                crit.medium_activity_thresold = 1;
            }
            if (crit.medium_activity_thresold >= (parseInt(crit.high_activity_thresold, 10) - 1)) {
                crit.high_activity_thresold = parseInt(crit.medium_activity_thresold, 10) + 1;
            }
            if (crit.high_activity_thresold >= (parseInt(crit.very_high_activity_thresold, 10) - 1)) {
                crit.very_high_activity_thresold = parseInt(crit.high_activity_thresold, 10) + 1;
            }
            this.$forceUpdate();
             this.changeOccured();
        },
        parse(value, defaultval) {
            if (value == '') {
                return defaultval;
            } else {
                return parseInt(value, 10);
            }
        },
        changeGroup(pt, value) {
            pt.group_id = value;
            pt.pest_id = null;
             this.changeOccured();
        },
        changePest(pt, value) {
            pt.group_id = null;
            pt.pest_id = value;
            this.changeOccured();
        },
        calcMethodChanged(crit) {
            if (crit.critical_calculation == "avg") crit.critical_point = 2.5;
            else if (crit.critical_calculation == "max") crit.critical_point = 2.0;
             this.changeOccured();
        },
        addTargetPest() {
            if (_.isUndefined(this.criterium.pests_thresolds)) {
                this.criterium.pests_thresolds = [];
            }
            this.criterium.pests_thresolds.push({
                pest_id: null,
                group_id: null,
                medium_activity_thresold: this.criterium.medium_activity_thresold,
                high_activity_thresold: this.criterium.high_activity_thresold,
                very_high_activity_thresold: this.criterium.very_high_activity_thresold,
                critical_point: this.criterium.critical_point,
                disaster_point: this.criterium.disaster_point,
                critical_calculation: "avg"
            })
            this.$forceUpdate();
            this.changeOccured();
        },
        removeTargetPest(criterium, tp) {
            if (tp.id != undefined) {
                tp._destroy = true;
            } else {
                this.criterium.pests_thresolds.splice(this.criterium.pests_thresolds.indexOf(tp), 1)
            }
            this.$forceUpdate();
            this.changeOccured();
        },
        changeOccured(){
            if(!_.isUndefined(this.criterium.id)){
                this.touched = true;
            }
        }
    },
    computed: {
        pestsByCategory() {
            return _.groupBy(_.sortBy(this.pests, 'name'), 'group_name')
        }
    }
}
</script>
<style scoped>
</style>